<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<p>Carol Watson 2022</p><br/>
<p>The right of Carol Watson to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p><br/>
<p>All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<br/>
<p>Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p><br/>
<p>The medical information in this book is not advice and should not be treated as such. Do not substitute this information for the medical advice of physicians. The information is general and intended to better inform readers of their health care. Always consult your doctor for your individual needs.</p><br/>
<p>A CIP catalogue record for this title is available from the British Library.</p><br/>
<p>ISBN 9781398454347 (Paperback)</p>
<p>ISBN 9781398454361 (ePub e-book)</p>
<p>ISBN 9781398454354 (Audiobook)</p><br/>
<p>www.austinmacauley.com</p><br/>
<p>First Published 2022</p>
<p>Austin Macauley Publishers Ltd<sup>®</sup></p>
<p>1 Canada Square</p>
<p>Canary Wharf</p>
<p>London</p>
<p>E14 5AA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?57f99ad8